import { render, staticRenderFns } from "./CrmRelativeTable.vue?vue&type=template&id=4b21a5a4&scoped=true"
import script from "./CrmRelativeTable.vue?vue&type=script&lang=js"
export * from "./CrmRelativeTable.vue?vue&type=script&lang=js"
import style0 from "./CrmRelativeTable.vue?vue&type=style&index=0&id=4b21a5a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b21a5a4",
  null
  
)

export default component.exports